var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-info"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.emptyClick}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.buttonText))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }